import { API } from "aws-amplify";

class ConfigService {
  private apiName = "";
  private apiBasePath = "";

  constructor() {
    // set api name
    this.apiName = "mailapi";
    this.apiBasePath = "/mail";
  }

  /*
    Task: get environment config values
  */
  async getEnvConfig(token = "") {
    // HTTP header
    const init = {
      headers: {
        Authorization: token,
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    };

    let response = {};

    try {
      const temp = await API.get(
        this.apiName,
        `${this.apiBasePath}/config`,
        init
      );

      // set data
      response = temp?.data?.secrets;
    } catch (error: any) {
      console.log(error);
      // set error
      response = {
        COGNITO_USER_POOL_REGION: "",
        COGNITO_USER_POOL_CLIENT_ID: "",
        COGNITO_USER_POOL_ID: "",
        AWS_ACCESS_KEY_ID: "",
        AWS_SECRET_KEY: "",
        MAPBOX_ACCESS_TOKEN: "",
        A4A_DOCUMENT_S3_BUCKET_NAME: "",
      };
    }

    return response;
  }
}

export { ConfigService };
